import { createReduxStore } from '#packages/apilib';
import { DESKTOP_CANVAS_SIZE, MOBILE_CANVAS_SIZE } from './consts';
import { getDesktopBreakpointDefinition } from './utils';
import type { BaseBreakpoint } from '@wix/document-services-types';
export interface BreakpointsState {
  activeBreakpoint: BaseBreakpoint | undefined;
}

const getInitialState = (): BreakpointsState => ({
  activeBreakpoint: getDesktopBreakpointDefinition(),
});

export const BreakpointsStore = createReduxStore({
  getInitialState,
  selectors: {
    getIsDesktopBreakpointActive: (state: BreakpointsState) =>
      state.activeBreakpoint.canvasSize === DESKTOP_CANVAS_SIZE,
    getIsMobileBreakpointActive: (state: BreakpointsState) =>
      state.activeBreakpoint.canvasSize === MOBILE_CANVAS_SIZE,
  },
  actions: {
    setActiveBreakpoint: (
      state: BreakpointsState,
      breakpoint: BaseBreakpoint,
    ) => {
      return {
        ...state,
        activeBreakpoint: breakpoint,
      };
    },
  },
});
